module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAP///wCZMyH5BAAAAAAALAAAAAAMAAwAAAITjI+pCu1rHpSsTbtoBTA43YVIAQA7"